import { Box, CollapsableCard, Icon, Text, Touchable } from '@factorialco/deprecated-design-system'
import { FinanceValueObjectsSpendingPolicyEvaluationResultTypeEnum } from 'generated/resources/graphql'
import moment from 'moment'
import { useToggle } from 'usehooks-ts'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { PolicyStatusCardContent } from 'modules/expenses/components/expenses/Detail/_Alerts/_PolicyStatusCard/_Content'
import { SpendingPolicyData } from 'modules/expenses/graphql/types'
import { Expensable } from 'modules/expenses/types/Expensable'

interface Props {
  expensable: Expensable
  policy: SpendingPolicyData
}

const getFilterDates = (effectiveOn: string, timeframe?: string) => {
  const date = moment(effectiveOn)
  let startDate, endDate

  switch (timeframe) {
    case 'per_expense':
      break
    case 'daily':
      startDate = date.clone()
      endDate = date.clone()
      break
    case 'weekly':
      startDate = date.clone().startOf('week')
      endDate = date.clone().endOf('week')
      break
    case 'monthly':
      startDate = date.clone().startOf('month')
      endDate = date.clone().endOf('month')
      break
    case 'yearly':
      startDate = date.clone().startOf('year')
      endDate = date.clone().endOf('year')
      break
    default:
      throw new Error(`Unhandled policy timeframe: ${timeframe}`)
  }
  return { startDate, endDate }
}

const PolicyStatusCard = ({ expensable, policy }: Props) => {
  const policyExceeded = policy.result === 'out_of_policy'
  const [showContent, toggleContent] = useToggle(policyExceeded)

  if (policy.result === 'not_applicable') return null

  const currency = policy.currency?.formatedValue

  const description: Record<FinanceValueObjectsSpendingPolicyEvaluationResultTypeEnum, string> = {
    within_policy: i18n.t('budgets.forms.external_resource.spending_policy.within_policy'),
    out_of_policy: i18n.t('budgets.forms.external_resource.spending_policy.out_of_policy'),
    not_applicable: '',
  }

  const { startDate, endDate } = getFilterDates(expensable.effectiveOn, policy?.timeframe?.value[0])

  const searchParams = new URLSearchParams()
  const categoryId = policy.category?.value[0]
  const subcategoryId = policy.subcategory?.value[0]

  if (categoryId) searchParams.set('category', categoryId)
  if (subcategoryId) searchParams.set('subcategory', subcategoryId)
  if (currency) searchParams.set('currency', currency)
  if (startDate) searchParams.set('startDate', dateToString(startDate, 'backend'))
  if (endDate) searchParams.set('endDate', dateToString(endDate, 'backend'))

  return (
    <CollapsableCard
      open={showContent}
      contentBackground="grey000White"
      contentPadding="s8"
      Card={
        <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
          <Text size="300" weight="semibold" color={policyExceeded ? 'radicalRed1200' : 'grey1000'}>
            {description[policy?.result]}
          </Text>
          <Touchable onClick={toggleContent}>
            <Icon.Small icon={showContent ? 'chevron-up' : 'chevron-down'} color="grey800" />
          </Touchable>
        </Box>
      }
      Content={<PolicyStatusCardContent policy={policy} />}
    />
  )
}

export default PolicyStatusCard
